import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@ff-os/shared-react/components/buttons/icon-button/IconButton';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { urls } from '@ff-os/shared-utils/urls';
import classNames from 'classnames';
import { setIsFotofunBannerHidden, selectIsFotofunBannerHidden, setisFotofunPanelOpen } from '../../../_redux-ui';
import { FotoFunTitle } from './FotoFunTitle';
import styles from './FotofunInPanelBanner.module.scss';

export const FotofunInPanelBanner = () => {

    const dispatch = useDispatch();
    const isMobile = useMobile();

    const panelIsHidden =  useSelector(selectIsFotofunBannerHidden);

    const hidePanel = () => {
        if (isMobile) {
            dispatch(setisFotofunPanelOpen(false));
        }
    };

    return (
        <div className={`${styles.panelBanner} ${panelIsHidden ? styles.hidden : ""}`}>
            <img src={urls.publicAssetUrl("b25c4685-2bb8-4fc3-b362-45aa34474c77")} alt="background image" className={styles.background} />
            <div className={styles.panelContent}>
                <div className={styles.fotofunTitleContainer}>
                    <FotoFunTitle />
                </div>
            </div>

            <div className={styles.animationContainer}>
                <div className={styles.maskedContainer} />
                <div className={styles.animationPlaceholder}>

                    <div className={styles.girlWrapper}>
                        <img src={urls.publicAssetUrl("1d63f9c2-d510-4bb5-bffe-c63b9d6cfac2")} className={classNames(styles.women, styles.women0)} />
                        <img src={urls.publicAssetUrl("a4ea83d2-d8c0-49a1-81f2-bb46cd450ce9")} className={classNames(styles.women, styles.womenHidden, styles.womenDots)} />
                        <img src={urls.publicAssetUrl("3e56c3bf-d025-4361-89f1-e0b44248c713")} className={classNames(styles.women, styles.womenHidden, styles.womenPaint)} />
                        <img src={urls.publicAssetUrl("6fe37ff6-97a3-404f-919b-9e5220e790bf")} className={classNames(styles.women, styles.womenHidden, styles.womenHearts)} />
                    </div>

                    <div className={styles.womenWrapper}>
                        <img src={urls.publicAssetUrl("0bead805-9ac5-4bea-b4be-eff085fbf5f9")} className={classNames(styles.women, styles.women0)} />
                        <img src={urls.publicAssetUrl("89a6a730-61b3-48f7-84f9-c930057b3532")} className={classNames(styles.women, styles.womenHidden, styles.womenDots)} />
                        <img src={urls.publicAssetUrl("542fa1ef-893a-462b-85db-95a3ab4d7b39")} className={classNames(styles.women, styles.womenHidden, styles.womenPaint)} />
                        <img src={urls.publicAssetUrl("252a9189-26b3-486c-beef-a64d56215bba")}  className={classNames(styles.women, styles.womenHidden, styles.womenHearts)} />
                    </div>

                    <img src={urls.publicAssetUrl("4171caed-8dfa-40cf-a643-7d5de37e61cf")} className={classNames(styles.shape, styles.dots, styles.dots1)} />
                    <img src={urls.publicAssetUrl("4171caed-8dfa-40cf-a643-7d5de37e61cf")} className={classNames(styles.shape, styles.dots, styles.dots2)} />

                    <img src={urls.publicAssetUrl("0bd829b9-68c2-43f9-b8ea-1816ad0ddba5")} className={classNames(styles.shape, styles.paint, styles.paint1)} />
                    <img src={urls.publicAssetUrl("0bd829b9-68c2-43f9-b8ea-1816ad0ddba5")} className={classNames(styles.shape, styles.paint, styles.paint2)} />

                    <img src={urls.publicAssetUrl("c9d8aaff-1bd4-44d4-b03e-8ff5a27cd17d")} className={classNames(styles.shape, styles.hearts, styles.hearts1)} />
                    <img src={urls.publicAssetUrl("c9d8aaff-1bd4-44d4-b03e-8ff5a27cd17d")} className={classNames(styles.shape, styles.hearts, styles.hearts2)} />

                    <div className={styles.animatingHandWrapper}>
                        <Icon type='animation-hand'
                            strokeWidth={1} size='small'
                            className={styles.animatingHand} />
                    </div>
                </div>
            </div>

            <IconButton small
                className={styles.panelBannerCloseButton}
                onClick={hidePanel}>
                <Icon type='general-ui-close' strokeWidth={2} size='small' />
            </IconButton>
        </div>
    );
};